import './js/anchor__public';